import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneNumber',
    standalone: true
})
export class PhoneNumberPipe implements PipeTransform {

  transform(value: string) {
    if (!value) {
      return value;
    }

    let digits = value.toString().trim().replace(/^\+/, '');

    // Handle any US country code phone numbers
    if (digits.length === 11 && digits.slice(0,1) === '1'){
      digits = digits.slice(1);
    }


    if (digits.match(/[^0-9]/) || digits.length !== 10) {
      return digits;
    }

    return `(${digits.substr(0, 3)}) ${digits.substr(3, 3)}-${digits.substr(6)}`.trim();
  }

  reverse(value: string) {
    const digits = value.toString().trim();
    return digits.replace(/[^0-9]/g, '');
  }
}
